import { TypographyStyleOptions } from '@material-ui/core/styles/createTypography'

interface FontStyle {
    [key: string]: TypographyStyleOptions
}

const fontStyles: FontStyle = {
    Title: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontStyle: 'normal',
        fontSize: '3rem',
        lineHeight: 1.5,
    },
    Title2: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '2rem',
        lineHeight: 1.5,
    },
    Title3: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '1.5rem',
        lineHeight: 1.5,
    },
    Subtitle: {
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontStyle: 'normal',
        fontSize: '1.25rem',
        lineHeight: 1.5,
    },
    NormalText: {
        fontFamily: 'Roboto',
        fontWeight: 300,
        fontStyle: 'normal',
        fontSize: '1rem',
        lineHeight: 1.5,
    },
    SmallText: {
        fontFamily: 'Roboto',
        fontWeight: 300,
        fontStyle: 'normal',
        fontSize: '0.75rem',
        lineHeight: 1.5,
    },
    ButtonText: {
        fontFamily: 'Roboto',
        fontWeight: 300,
        fontStyle: 'normal',
        fontSize: '1rem',
        lineHeight: 1.5,
        textDecoration: 'none',
    },
}

export default fontStyles
